
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const vdi: IProductData = {
  id: "hazelriggindustries-vdi",
  name: "Hazelrigg Industries VDI",
  description: "VDI is an all-triode Vacuum Tube Direct Box in a single channel configuration.",
  specialOrder: true,
  images: ["/img/hazelriggindustries_vdi_front.png", "/img/hazelriggindustries_vdi_back.png", "/img/hazelriggindustries_vdi.jpg"],
  details: [{
    label: "Description",
    markdown: `
The Hazelrigg Industries VDI Vacuum Tube DI is designed to provide recording professionals with a sonically superior method for recording electric and electronic musical instruments by direct injection (DI).  
Any instrument designed to operate into a “guitar amp” will work perfectly with the VDI.  
Typical instruments include: electric bass, electric guitar, electric piano, acoustic instruments with a pickup (piano, acoustic guitar, electric violin, etc.), synthesizers, and samplers.  
  
The VDI is a single-channel device that provides the optimum load impedance for these instruments.  
It is capable of quality reproduction of a wide range of instrument levels.  
The unit does not have the limitations of passive transformer-type DIs, and has greater headroom and warmth when compared to similar solidstate devices.  

It is designed to operate in the professional recording or performing environment.  
The output level is “hot” mic level (-30 dBm nominal).  
The output is transformer-balanced, using a custom transformer built for us by Jensen Transformers, Inc., and is designed to match 150 ohm professional mic inputs.  
Top-quality parts are used throughout.  
The case is machined from solid quarter-inch thick aluminum plate for ruggedness and durability.  
Both the filament and plate power supplies are fully regulated.  

The VDI is not mass-produced. Each one is hand-made and meticulously test- ed before shipment to the customer.
`
  }, {
    label: "Specifications",
    markdown: `
- Input: 200 mV nominal unbalanced
- Input Load Impedance: 1 megohm minimum
- Minimum Input Level: 5 mV nominal
- Maximum Input Level: 2.3 volts P-P for 1% THD
- Gain: -10 dB
- Frequency Response: +/- 0.2 dB 10 cps to 20 kc, -3 dB @ 0.5 cps and 95 kc
- THD + Noise: <0.3% 20 cps to 20 kc
- Intermodulation Distortion: <0.01% SMPTE
- Noise: minimum 90 dB below output (22 cps to 22 kc bandwidth)
- Output: Transformer Balanced (matches 150 ohm input)
- Output Level: -30 dBm nominal
- Maximum Output Level: -12 dBm
- Power Requirements: 120/220 VAC 50/60Hz 25W
- Dimensions: 6.25”W x 2.25”H x 9.5”D (15.9cm x 5.7cm x 24.2cm)
- Weight: 6 lbs. (2.73kg)
`
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://www.hazelriggindustries.com/vdi-di-box" target="_blank">https://www.hazelriggindustries.com/vdi-di-box</a>
    `
  }],
  videos: [],
  metadata: {
    hashtags: [HASHTAGS.LIVE_SOUND, HASHTAGS.RECORDING, HASHTAGS.DI],
    manufacturer: BRAND.HAZELRIGG,
  }
}